import React, { useState } from "react";
import PropTypes from "prop-types";

/**
 * Modal shown when an API fails and fallback/mock data is available
 * Gives user option to: Continue with mock, Try again, or Go back
 */
function FallbackErrorModal({
  isOpen,
  operationName,
  errorMessage,
  errorDetails,
  onContinueWithMock,
  onTryAgain,
  onGoBack,
}) {
  const [showDetails, setShowDetails] = useState(false);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden">
        {/* Content */}
        <div className="px-6 py-8 space-y-6">
          {/* Error Icon */}
          <div className="flex justify-center">
            <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center">
              <svg
                className="w-8 h-8 text-orange-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
          </div>

          {/* Title */}
          <div className="text-center space-y-3">
            <h3 className="text-2xl font-semibold text-gray-900">
              Error
            </h3>
            <p className="text-base text-gray-600 leading-relaxed px-4">
              Your search session has expired. Please go back and search again to continue with your booking.
            </p>
          </div>
        </div>

        {/* Actions */}
        <div className="px-6 pb-6 flex flex-col gap-3">
          {/* Primary action - Try Again */}
          {/* <button
            onClick={onTryAgain}
            className="w-full px-4 py-3 bg-orange-500 hover:bg-orange-600 text-white rounded-lg font-medium transition-colors flex items-center justify-center gap-2 shadow-sm"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              />
            </svg>
            Try Again
          </button> */}

          {/* Secondary actions */}
          <div className="grid grid-cols-1 gap-3">
            {/* <button
              onClick={onContinueWithMock}
              className="px-4 py-2.5 bg-white hover:bg-gray-50 text-gray-700 border border-gray-300 rounded-lg font-medium transition-colors text-sm"
            >
              Continue with Demo
            </button> */}
            <button
              onClick={onGoBack}
              className="px-4 py-2.5 bg-white hover:bg-gray-50 text-gray-700 border border-gray-300 rounded-lg font-medium transition-colors text-sm"
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

FallbackErrorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  operationName: PropTypes.string.isRequired,
  errorMessage: PropTypes.string.isRequired,
  errorDetails: PropTypes.string,
  onContinueWithMock: PropTypes.func.isRequired,
  onTryAgain: PropTypes.func.isRequired,
  onGoBack: PropTypes.func.isRequired,
};

export default FallbackErrorModal;
